import React from 'react';
import MessageList from './MessageList';
import MessageThread from './MessageThread';
import { getUnifiedTimestamp } from '../utils/combinedMessageUtils';

export const WhatsAppLayout = ({
  messages,
  groupedChats,
  unifiedContacts,
  filteredContacts,
  selectedContact,
  onSelectContact,
  onSendMessage,
  whatsappRole,
  error,
  isLoading,
  pageInfo,
  onLoadPrev,
  onLoadNext,
  lastVisible,
  firstVisible,
  filterButtonMessages
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* Contact List Sidebar */}
      <div className="lg:col-span-1">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200">
          <div className="px-4 py-3 border-b border-gray-200">
            <h2 className="font-semibold text-gray-900">Conversations</h2>
          </div>
          <div className="max-h-96 overflow-y-auto p-4">
            {error ? (
              <div className="text-center py-8">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-red-100 rounded-full mb-4">
                  <span className="text-xl">❌</span>
                </div>
                <p className="text-red-600">{error}</p>
              </div>
            ) : Object.keys(unifiedContacts || groupedChats).length === 0 ? (
              <div className="text-center py-8">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-gray-100 rounded-full mb-4">
                  <span className="text-xl">💬</span>
                </div>
                <p className="text-gray-600">No conversations found</p>
              </div>
            ) : (
              <MessageList
                contacts={filteredContacts}
                selectedContact={selectedContact}
                onSelectContact={onSelectContact}
              />
            )}
          </div>

          {/* Pagination */}
          <div className="px-4 py-3 border-t border-gray-200">
            <div className="flex items-center justify-between">
              <button
                onClick={onLoadPrev}
                disabled={pageInfo.page === 1 || isLoading}
                className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed rounded"
              >
                Previous
              </button>
              <span className="text-sm text-gray-600">
                Page {pageInfo.page} {pageInfo.isLast && '(Last)'}
              </span>
              <button
                onClick={onLoadNext}
                disabled={pageInfo.isLast || isLoading}
                className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed rounded"
              >
                Next
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Message Thread */}
      <div className="lg:col-span-2">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 h-[600px]">
          <MessageThread
            selectedContact={selectedContact}
            contacts={Object.values(unifiedContacts || groupedChats)}
            onSendMessage={onSendMessage}
            whatsappRole={whatsappRole}
            filterButtonMessages={filterButtonMessages}
          />
        </div>
      </div>
    </div>
  );
};

export default WhatsAppLayout;
